import "./dadosAprovador.css";
import edit from "../../../assets/svgs/edit.svg";

type DadosAprovadorInfos = {
    email: string, 
    crea: any,
    onEditCrea?: () => void
}

export const DadosAprovador = ({
    email, 
    crea,
    onEditCrea,
} : DadosAprovadorInfos) => {
    return (
        <>
        <div className="headerRequest">
            <span className="titleRequest">Dados do Aprovador</span>
        </div>

        <div className="containerDataApprover">
            <div className="dataRow">
                <span className="dataLabel">E-mail:</span>
                <span className="dataValue">{email}</span>
            </div>

            <div className="dataRow">
                <span className="dataLabel">CREA:</span>

                <div className="dataValueWithAction">
                    <span className="dataValue">{crea}</span>
                    <button
                        type="button"
                        onClick={onEditCrea}
                    >
                        <img 
                            className="iconEdit" 
                            src={edit} 
                            alt="Editar CREA" 
                        />
                    </button>
                </div>
            </div>
        </div>        
        </>
    )
}